__turbopack_context__.v({
  "captchaContainer": "ContactForm-module-scss-module__BuRZbG__captchaContainer",
  "container": "ContactForm-module-scss-module__BuRZbG__container",
  "fullWidth": "ContactForm-module-scss-module__BuRZbG__fullWidth",
  "input": "ContactForm-module-scss-module__BuRZbG__input",
  "messageIcon": "ContactForm-module-scss-module__BuRZbG__messageIcon",
  "textarea": "ContactForm-module-scss-module__BuRZbG__textarea",
});
